import { Box, Grid } from "@mui/material";
import { FormikProps } from "formik";
import AsyncSelect, {
  AsyncSelectValue,
} from "../../../../../components/AsyncSelect";
import ErrorHelper from "../../../../../components/ErrorWrapper";
import Flex from "../../../../../components/Flex";
import { ProcedureCodeFormRow, ProcedureRowField } from "../billing-types";
import { DiagnosisKeys, MODIFIER_KEYS } from "./constant";
import { useDiagnosisPointersOptionController } from "./use-diagnosis-pointers-option-controller";

interface DiagnosisPointersProps {
  viewBill: boolean;
  procedureCodeFormik: FormikProps<ProcedureCodeFormRow[]>;
  selectHandleChange: (
    k: ProcedureRowField,
    v: string | AsyncSelectValue | null,
    idx: number
  ) => void;
  idx: number;
  diagnosisCodesLength: number;
  /** Marks the group mandatory with an asterisk on the label. */
  required?: boolean;
  /** Group-level message; also puts every pointer select in the error state. */
  error?: string | boolean;
}

const DiagnosisPointers = ({
  viewBill,
  procedureCodeFormik,
  selectHandleChange,
  idx,
  diagnosisCodesLength,
  required,
  error,
}: DiagnosisPointersProps) => {
  const { options, handleChange } = useDiagnosisPointersOptionController(
    procedureCodeFormik.values,
    idx,
    diagnosisCodesLength
  );

  const vals = procedureCodeFormik.values?.[idx];

  const getTransformedValues = (
    key: DiagnosisKeys
  ): null | AsyncSelectValue => {
    const currentVal = vals?.[key];

    if (!currentVal) return null;

    return {
      value: currentVal,
      label: currentVal,
    };
  };

  return (
    <Grid item xs={3}>
      <ErrorHelper label="Diagnosis Pointer" required={required} error={error}>
        <Flex gap={2}>
          {MODIFIER_KEYS.map((key) => (
            <Box width={"70px"} key={key}>
              <AsyncSelect
                forcePopupIcon={false}
                width={75}
                disabled={!viewBill}
                // Boolean, not the message: the group renders one message on the
                // label above instead of repeating it under all four selects.
                error={!!error}
                options={options[key].map((opt) => ({
                  value: opt,
                  label: opt,
                }))}
                value={getTransformedValues(key)}
                onChange={(value: AsyncSelectValue | null) => {
                  handleChange(key, value?.value ?? "");
                  selectHandleChange(key, value?.value ?? "", idx);
                }}
              />
            </Box>
          ))}
        </Flex>
      </ErrorHelper>
    </Grid>
  );
};

export default DiagnosisPointers;
